import { StandardProps } from "../componentMap";
import { CreditOfferUI } from "./CreditOfferUI";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { dispatchAnalyticsEvent } from "../../utils";
import { CreditIllustration } from "@/types/cobeTypes";

export function CreditOffer({
  product,
  configProps,
  creditOffersV2,
  flags,
}: Pick<
  StandardProps,
  "product" | "configProps" | "creditOffersV2" | "flags"
>) {
  const { variant, isSelected } = useVariant(product);
  const shouldHideIfIBCOnly = configProps?.shouldHideIfIBCOnly;

  if (flags.showPaymentPlans.value) return null;

  if (!isSelected) return null;

  const skuOffers = creditOffersV2?.find(
    ({ skuId }) => skuId === variant.aliases.skuId,
  );
  if (!skuOffers) return null;

  if (typeof shouldHideIfIBCOnly === "undefined") return null;

  const itemClickHandler = (subtype: string, type = "pdp") => {
    dispatchAnalyticsEvent(
      "global.interaction",
      { type: type, subType: subtype },
      {
        products: [
          {
            brand: product.brand?.name || "",
            category:
              product.browsePageHierarchy[
                product.browsePageHierarchy.length - 1
              ]?.categoryId,
            sku: variant.aliases.skuId,
            price: variant.price?.value || "",
            productName: variant.title,
            productId: product.aliases.pimProductId,
          },
        ],
      },
    );
  };

  const iBCItemAnalyticsHandler = (subtype: string, type: string) => {
    dispatchAnalyticsEvent(
      "global.interaction",
      { type: type, subType: subtype },
      {
        products: [],
        additionalInfo: {},
        properties: {},
      },
    );
  };

  const jlOffers: CreditIllustration[] = skuOffers.creditIllustrations.filter(
    (illustration) => {
      return illustration.creditProvider === "BNPP";
    },
  );

  return (
    <CreditOfferUI
      offers={jlOffers}
      ibcDisclaimerAnalyticsClickHandler={iBCItemAnalyticsHandler}
      ifcDisclaimerAnalyticsClickHandler={itemClickHandler}
      shouldHideIfIBCOnly={shouldHideIfIBCOnly === true}
    />
  );
}
